{
  "name": "@vercel/flags",
  "version": "3.1.1",
  "description": "Flags SDK by Vercel - The feature flags toolkit for Next.js and SvelteKit",
  "keywords": [
    "feature flags",
    "Next.js",
    "react",
    "toolbar",
    "overrides",
    "SvelteKit"
  ],
  "homepage": "https://flags-sdk.dev",
  "bugs": {
    "url": "https://github.com/vercel/flags/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/vercel/flags.git"
  },
  "license": "MIT",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./next": {
      "import": "./dist/next.js",
      "require": "./dist/next.cjs"
    },
    "./analytics": {
      "import": "./dist/analytics.js",
      "require": "./dist/analytics.cjs"
    },
    "./react": {
      "import": "./dist/react.js",
      "require": "./dist/react.cjs"
    },
    "./sveltekit": {
      "import": "./dist/sveltekit.js",
      "require": "./dist/sveltekit.cjs"
    }
  },
  "typesVersions": {
    "*": {
      "*": [
        "dist/*.d.ts",
        "dist/*.d.cts"
      ],
      "next": [
        "dist/next.d.ts",
        "dist/next.d.cts"
      ],
      "react": [
        "dist/react.d.ts",
        "dist/react.d.cts"
      ],
      "sveltekit": [
        "dist/sveltekit.d.ts",
        "dist/sveltekit.d.cts"
      ]
    }
  },
  "files": [
    "dist",
    "CHANGELOG.md"
  ],
  "scripts": {
    "attw": "attw --pack .",
    "build": "tsup",
    "dev": "tsup --watch --clean=false",
    "eslint": "eslint-runner",
    "eslint:fix": "eslint-runner --fix",
    "test": "vitest --run",
    "test:watch": "vitest",
    "type-check": "tsc --noEmit"
  },
  "dependencies": {
    "@edge-runtime/cookies": "^5.0.2",
    "jose": "^5.2.1"
  },
  "devDependencies": {
    "@arethetypeswrong/cli": "0.17.3",
    "@types/node": "20.11.17",
    "@types/react": "18.2.55",
    "@vitejs/plugin-react": "4.2.1",
    "eslint-config-custom": "workspace:*",
    "msw": "2.6.4",
    "next": "15.1.4",
    "react": "canary",
    "tsconfig": "workspace:*",
    "tsup": "8.0.1",
    "typescript": "5.6.3",
    "vite": "5.1.1",
    "vitest": "1.4.0"
  },
  "peerDependencies": {
    "@opentelemetry/api": "^1.7.0",
    "@sveltejs/kit": "*",
    "next": "*",
    "react": "*",
    "react-dom": "*"
  },
  "peerDependenciesMeta": {
    "@opentelemetry/api": {
      "optional": true
    },
    "@sveltejs/kit": {
      "optional": true
    },
    "next": {
      "optional": true
    },
    "react": {
      "optional": true
    },
    "react-dom": {
      "optional": true
    }
  },
  "publishConfig": {
    "access": "public"
  }
}
